import { LinkedEntitlementRelationShipType } from '../../types';
import { cartLinkedEntitlement } from '../../ui/product-line-items/src/types';

export const sortLinkedEntitlements = (linkedEntitlements: cartLinkedEntitlement[] = []) => {
  return linkedEntitlements.sort((a, b) => {
    // prioritizing ADD_ON first
    if (
      a?.relationshipType === LinkedEntitlementRelationShipType.ADD_ON &&
      b?.relationshipType === LinkedEntitlementRelationShipType.APP
    )
      {return -1;}
    if (
      a?.relationshipType === LinkedEntitlementRelationShipType.APP &&
      b?.relationshipType === LinkedEntitlementRelationShipType.ADD_ON
    )
      {return 1;}

    // sorting alphabetically by name within the same relationshipType
    return a?.name.localeCompare(b?.name);
  });
};
